export const internalStoreColumns = (t: any) => [
  {
      key: "storeName",
      name: t("internalStore.columns.storeName"),
      fieldName: "storeName",
      minWidth: 250,
      maxWidth: 300,
      isResizable: true,
  },
  {
      key: "containersAmount",
      name: t("internalStore.columns.containerCount"),
      fieldName: "containersAmount",
      minWidth: 350,
      maxWidth: 500,
      isResizable: true,
  }
];